export default {
      id: "media_tab_photos-usage",
      viewBox: "0 0 25 22",
      url: "/" + "sprite.svg#media_tab_photos",
      toString: function () {
        return this.url;
      }
    }